import { passwordValidation } from '@alluradirect/react';
import { ForgotPasswordForm } from 'components/views/pages/forgot-password/ForgotPasswordForm';
import {
  ForgotPasswordFormikValues,
  forgotPasswordInitialValues,
  generateResetPasswordInitialValues,
} from 'components/views/pages/forgot-password/initialValues';
import { ResetPasswordForm } from 'components/views/pages/forgot-password/ResetPasswordForm';
import { UserForgotPasswordReturn } from 'components/views/pages/forgot-password/useForgotPassword';
import { Form, Formik } from 'formik';
import { useMemo } from 'react';

interface Props {
  hasTopAppDivider?: boolean;
  initialEmail?: string;
}

export const ForgotResetFormik = (props: UserForgotPasswordReturn & Props) => {
  const initialResetPasswordValues = generateResetPasswordInitialValues(props.user?.EMAIL);
  const initialForgotPasswordValues: ForgotPasswordFormikValues = useMemo(() => {
    if (props.initialEmail) return { email: props.initialEmail };
    return forgotPasswordInitialValues;
  }, [props.initialEmail]);

  if (props.verified) {
    return (
      <Formik
        onSubmit={props.onSubmitResetPassword}
        initialValues={initialResetPasswordValues}
        validationSchema={passwordValidation}
        enableReinitialize
      >
        <Form>
          <ResetPasswordForm />
        </Form>
      </Formik>
    );
  }

  return (
    <ForgotPasswordForm
      setVerified={props.setVerified}
      setUser={props.setUser}
      hasTopAppDivider={props.hasTopAppDivider}
      initialForgotPasswordValues={initialForgotPasswordValues}
    />
  );
};
